import { GET_MENU_V3_RESPONSE } from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_V3_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: action.response.menu,
      };

    default:
      return state;
  }
};

export const selectMenu = (state, menuSlug) => state[menuSlug] || {};
